import React from 'react';

export default function ErrorRange() {
    return (
        <div className="row flexBoxRowSCC">
            <div className="col-6 text-center">
                <h3>No data found.</h3>
            </div>
        </div>    
    );
}